export default {
    data: () => ({
        translations: {
            title: {
                el: "Κουπόνια με έκπτωση",
                en: "Coupons with discount",
                it: "Buoni con sconto"
            },
            info: {
                el: "Επιτρέψτε στον πελάτη σας να πάρει τα προϊόντα σας με έκπτωση όταν έχει συγκεκριμένο ποσό πόντων από συναλλαγές στο κατάστημά σας. Ορίστε για κάθε προϊόν το ποσοστό της έκπτωσης που σας ταιριάζει με βάση τα περιθώρια κέρδους σας.",
                en: `Let your customer get your products with discount when they
                    have certain amount of points from transactions to your
                    store. Set for each product the percentage of the discount
                    that suits you based on your margins.`,
                it: "Lascia che il tuo cliente ottenga i tuoi prodotti con lo sconto quando ha una certa quantità di punti dalle transazioni al tuo negozio. Imposta per ogni prodotto la percentuale di sconto che ti conviene in base ai tuoi margini."
            },
            addDiscountCoupons: {
                el: "Προσθήκη Εκπτωτικών Κουπονιών",
                en: "Add Discount Coupons",
                it: "Aggiungi coupon di sconto"
            },
            product: {
                el: "Όνομα Προϊόντος",
                en: "Product Name",
                it: "Nome del prodotto"
            },
            discount: {
                el: "Έκπτωση",
                en: "Discount",
                it: "Sconto"
            },
            points: {
                el: "Πόντοι",
                en: "Points",
                it: "Punti"
            },
            date: {
                el: "Ημερομηνία",
                en: "Date",
                it: "Data"
            },
            actions: {
                el: "Ενέργειες",
                en: "Actions",
                it: "Azioni"
            },
            noData: {
                el: "Δεν υπάρχουν δεδομένα",
                en: "No data available",
                it: "Nessun dato disponibile"
            },
            delete: {
                el: "Διαγραφή",
                en: "Delete",
                it: "Cancellare"
            },
            deleteDiscount: {
                el: "",
                en: "Delete Discount",
                it: ""
            },
            areYouSure: {
                el: "",
                en: "Are you sure you want to delete",
                it: ""
            },
            paginationText: {
                el: "από",
                en: "of",
                it: "di"
            }
        }
    })
};
